<template>
  <div>
    <el-table
      :data="paginatedPickups"
      size="mini"
      stripe
    >
      <el-table-column
        label="Created At"
        prop="created_at"
        :formatter="(row, col, cellValue) => cellValue ? ($moment(cellValue).format('llll') || '-') : '-'"
      />
      <el-table-column label="Booking Ref.">
        <template slot-scope="scope">
          <router-link
            v-if="!!scope.row.id"
            :to="{ name: 'customerservice-pickups-pickup', params: { pickupId: scope.row.id } }"
          >
            {{ scope.row.booking_reference }}
          </router-link>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Carrier Ref.">
        <template slot-scope="scope">
          <u
            v-if="!!scope.row.carrier_reference"
            v-clipboard:copy="scope.row.carrier_reference"
            v-clipboard:success="() => $message({ message: 'Copied to clipboard', type: 'success' })"
            v-clipboard:error="() => $message({ message: 'An error occurred while copying to clipboard', type: 'error' })"
            v-tooltip="'Click to copy'"
          >
            {{ scope.row.carrier_reference }}
          </u>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Status">
        <template slot-scope="scope">
          <el-tag :type="getTagByStatus(scope.row.status)">
            {{ formatTitle(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 30]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import { titleize } from 'inflected'
import { statusTag } from '@/components/Application/CustomerService/Pickups/Pickup/PickupFunctions'
export default {
  props: {
    pickups: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      page: 1,
      perPage: 10,
      total: this.pickups.length
    }
  },
  computed: {
    paginatedPickups () {
      let startIndex = (this.page * this.perPage) - this.perPage
      let endIndex = startIndex + this.perPage
      return this.pickups.slice(startIndex, endIndex)
    }
  },
  methods: {
    getTagByStatus (status) {
      return statusTag(status)
    },
    formatTitle (title) {
      return titleize(title)
    }
  }
}
</script>

<style>

</style>
